var React = require('react');

function Transforming (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .forms {\n        fill:#e5fd57;\n        stroke:#000;\n        stroke-miterlimit:10;\n      }\n    ")),React.createElement("path",{"className":"forms","d":"M.65,390,118.29,85.39,281.55.71l120,346.41-162,128.56Z","key":1})]);
}

Transforming.defaultProps = {"id":"transforming","data-name":"transforming","viewBox":"0 0 402.18 476.24"};

module.exports = Transforming;

Transforming.default = Transforming;
